import { useQuery } from '@tanstack/react-query'

import { GetSearchBoxBannerViewModel } from '@/types/cml-api'

import fetchRequest from '@/app/_utils/fetch-request'
import { QueryKeys } from '@/app/_utils/react-query'

export function useGetSearchboxBanner() {
    return useQuery<unknown, unknown, GetSearchBoxBannerViewModel>({
        queryKey: QueryKeys.Layout.SearchboxBanner,
        queryFn: () =>
            fetchRequest({
                endpoint: '/search-box-banners',
                method: 'GET',
                serviceName: 'cml',
            }),
        refetchOnMount: false,
    })
}
